<template>
  <div class="header">
    <div class="header-content">
      <p>{{ title }}</p>
    </div>
    <div class="btn-menu" v-if="!token">
      <el-button round size="medium" @click="login('login')"
        >登录学习
      </el-button>
    </div>
    <div class="drop-menu" v-else>
      <el-badge :is-dot="unread" style="margin-top: 5px; margin-right: 30px">
        <el-popover
          ref="messagePopover"
          placement="bottom"
          width="400"
          @show="getMessageList"
          trigger="click"
        >
          <div class="table-box">
            <el-table
              size="mini"
              style="width: 100%"
              :data="messageList"
              :row-class-name="tableRowClassName"
              @expand-change="handleExpandChange"
            >
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-card>
                    <p style="line-height: 1.5; font-size: 13px">
                      {{ props.row.content }}
                    </p>
                  </el-card>
                </template>
              </el-table-column>
              <el-table-column property="title" width="120" label="标题">
              </el-table-column>
              <el-table-column
                property="addTime"
                label="日期"
                fixed="right"
              ></el-table-column>
            </el-table>
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 30, 40]"
                :current-page.sync="page"
                :page-size="pageSize"
                layout="total, prev, pager, next,jumper"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
          <el-button
            type="text"
            slot="reference"
            style="margin-top: -2px; color: #606266; font-size: 14px"
            >我的消息
          </el-button>
        </el-popover>
      </el-badge>
      <div class="avatar-wrapper" @click="goPersonalCenter">
        <el-avatar
          :size="40"
          :src="userInfo.headImg || defaultAvatar"
          style="cursor: pointer"
        />
      </div>
      <el-dropdown>
        <span class="el-dropdown-link"
          >{{ userInfo?.name }}
          <i class="el-icon-arrow-down el-icon--right" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="goPersonalCenter"
            >个人中心</el-dropdown-item
          >
          <el-dropdown-item @click.native="goToSubmission"
            >提交记录</el-dropdown-item
          >
          <el-dropdown-item divided @click.native="logout()"
            ><span style="display: block">退出登录</span></el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { mapActions, mapGetters } from "vuex";
import { getMessageList, getmessageCount, messageRead } from "@/apis/user";
export default {
  data() {
    return {
      messageList: [],
      token: getToken() || "",
      defaultAvatar:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      page: 1,
      pageSize: 10,
      total: 0,
      pollInterval: null,
      unread: false,
    };
  },
  computed: {
    title() {
      return this.$route.meta.herderTitle ? this.$route.meta.herderTitle : "";
    },
    ...mapGetters("user", ["userInfo"]),
  },
  created() {
    this.$store.dispatch("user/fetchUserInfo");
  },
  mounted() {
    this.getmessageCount();
  },
  methods: {
    ...mapActions("user", ["clear"]),
    tableRowClassName({ row, rowIndex }) {
      if (!row.read) {
        return "unread-row";
      }
      return "";
    },
    handleExpandChange(row, expandedRows) {
      if (expandedRows.includes(row)) {
        this.handleRowExpand(row);
      }
    },
    async handleRowExpand(row) {
      if (row.read) return;
      const res = await messageRead({ idList: [row.id] });
      if (res.msg == "提交成功") {
        row.read = true;
        this.getmessageCount();
      }
    },
    async getmessageCount() {
      const res = await getmessageCount();
      if (res.data > 0) {
        this.unread = true;
      } else {
        this.unread = false;
      }
      this.handlePolling();
    },
    async getMessageList() {
      try {
        const res = await getMessageList({
          page: this.page,
          pageSize: this.pageSize,
        });
        this.messageList = res.records;
        this.total = res.total;
      } catch (error) {}
    },
    handlePolling() {
      if (this.pollInterval) return;
      this.pollInterval = setInterval(() => {
        this.getmessageCount();
      }, 60 * 60 * 1000);
    },
    stopPolling() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
        this.pollInterval = null;
      }
    },
    goPersonalCenter() {
      if (this.$route.path !== "/user") {
        this.$router.push("/user");
      }
    },
    goToSubmission() {
      if (this.$route.path !== "/submission") {
        this.$router.push("/submission");
      }
    },
    login(path) {
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
    logout() {
      this.clear();
      this.$router.push(`/login`);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMessageList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getMessageList();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .unread-row {
  background-color: #f7edee !important;
}
::v-deep .el-dropdown-menu__item:focus,
::v-deep .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #f0f0f0;
  /* 修改鼠标悬停时的背景颜色 */
  color: #8c52da;
  /* 修改鼠标悬停时的文字颜色 */
}

.header-content {
  p {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #667eea);
    background-size: 300% 100%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-shadow: 0 2px 10px rgba(102, 126, 234, 0.3);
    letter-spacing: 2px;
    position: relative;
    animation: gradient-move 4s linear infinite;
  }
}
@keyframes gradient-move {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  height: 60px;
  align-items: center;
  padding: 0 20px;

  border-bottom: 1px solid #ede9e9;
}

.btn-menu {
  float: right;

  .el-button {
    letter-spacing: 0.1rem;
    color: #fff;
    background-color: #8c52da;
    border: none;
  }
}

.drop-menu {
  .avatar-wrapper {
    width: 44px; /* 40 + 2*2 */
    height: 44px;
    border-radius: 50%;
    cursor: pointer;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
    padding: 3px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
  }
  & {
    display: flex;
  }

  & {
    align-items: center;
  }

  & {
    float: right;
  }

  & {
    position: absolute;
  }

  & {
    right: 30px;
  }

  .el-dropdown-link {
    font-size: 18px;
  }

  &-title {
    font-size: 18px;
  }
}
</style>
